//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { mapState } from 'vuex'
import Logpop from '../components/elogpop/index.vue'
	export default{
		name:'vessel',
		data(){
			return{

			}
		},
		
		created() {


			this.$store.commit('setInfo');
			
			if(this.user.userType != 1){
				this.$router.push({ name : 'home'});
			}

			if(this.user.nickname){
				this.set_scrape()
			}
		},
		
		methods:{
			refresh(){
				this.$router.go(0)
			}
		},
		
		computed:{
			...mapState(['official_loading', 'messageData','logpopShow','user'])
		},
		
		components:{
			leftcolumn: () => import ('../components/leftcolumn/index.vue'),
			rightcolumn: () => import ('../components/rightcolumn/index.vue'),
			loading: () => import ('../components/loading/index.vue'),
			messagebox: () => import ('../components/messagebox/index.vue'),
			Logpop
		}
	}
